import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { setLanguage } from '../actions/language.actions';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { rtlLangs } from '@sukna/shared';
import { translateFileLang } from '../../shared/utils/translate-file-lang';

@Injectable()
export class LanguageEffects {
  private actions$ = inject(Actions);
  private translate = inject(TranslateService);
  private document = inject(DOCUMENT);

  setLang$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setLanguage),
        tap(({ language }) => {
          localStorage.setItem('lang', language);
          this.translate.use(translateFileLang(language));
          this.document.documentElement.lang = language === 'ar' ? 'ar' : language;
          this.document.documentElement.dir = isRtlLanguage(language) ? 'rtl' : 'ltr';
        })
      ),
    { dispatch: false }
  );
}

function isRtlLanguage(lang: string): boolean {
  
  return rtlLangs.includes(lang?.toLowerCase());
}
